import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SVGIcon from './svg-icon';

/**
 * Fancy radio buttons. This component is really just a group of radio buttons
 * with containers to target for fancy styling.
 *
 * Accepts 'options' array of objects of shape: {
 * 	label: option label,
 *  iconName: name of svg symbol to display next to option label,
 *  id: unique id for this radio button,
 *  name: unique name for radio button group,
 *  value: value for this radio button,
 *  checked: boolean or expression that evaluates to a boolean,
 *  callback: function to fire upon checking this radio button
 * }
 */
export default class ToggleSelector extends React.Component {
  getRadios = options => {
    return options.map(option => {
      if (!option.id) {
        throw new Error('Toggle option is missing a valid id attribute.');
      }

      if (!option.name) {
        throw new Error('Toggle option is missing a valid name attribute.');
      }

      if (option.callback && typeof option.callback !== 'function') {
        throw new Error('Toggle option callback is not a valid function.');
      }

      const value = option.value === undefined ? '' : option.value;
      const checked = option.checked === true;
      const callback = option.callback || null;

      const classes = classNames({
        selected: option.checked,
        disabled: option.disabled === true
      }, 'option');

      return (
        <div className={classes} key={option.id} onClick={() => this.handleClick(checked, value, callback)}>
          {
            option.iconName &&
              <SVGIcon name={option.iconName} />
          }
          <input
            type='radio'
            id={option.id}
            name={option.name}
            value={value}
            checked={checked}
            readOnly
          />
          {
            option.label &&
              <label>{option.label}</label>
          }
        </div>
      );
    })
  };

  handleClick = (checked, value, callback) => {
    if (!checked && callback) {
      callback(value)
    }
  };

  render () {
    const classes = classNames({
      disabled: this.props.disabled === true
    }, 'toggle-selector')

    return (
      <div className={classes}>
        { this.getRadios(this.props.options) }
      </div>
    );
  }
}

ToggleSelector.propTypes = {
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/main/webapps/common/react/components/toggle-selector.js